import { withInstall } from '@lit-element/utils'

import Card from './src/card.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtCard: SFCWithInstall<typeof Card> = withInstall(Card)
export default LtCard

export * from './src/card'
export type { CardInstance } from './src/instance'
